import StatusTogglerView from './status_toggler_view';

const StatusToggler = StatusTogglerView;

export default StatusToggler;
